<!-- Apply Employee Leave modal -->
<div
  id="add_employee_leave"
  class="modal custom-modal fade"
  role="dialog"
  style="display: none"
  data-select2-id="add_leave"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Leave</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCloseModal()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="applyLeaveForm" (ngSubmit)="onSubmitLeave()">
          <div class="row" *ngIf="isManager">
            <label class="col-form-label col-md-4 col-sm-4"
              >Applying For<span class="text-danger">*</span></label
            >
            <div class="col-md-8 col-sm-8 mt-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  [(ngModel)]="behalf"
                  formControlName="is_on_behalf"
                  type="radio"
                  value="0"
                  (change)="isOnBehalf($event)"
                />
                <label class="form-check-label" for="">Own</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  [(ngModel)]="behalf"
                  formControlName="is_on_behalf"
                  type="radio"
                  value="1"
                  (change)="isOnBehalf($event)"
                />
                <label class="form-check-label" for="">Others</label>
              </div>
            </div>
          </div>
          <hr *ngIf="isManager" />
          <!-- <div class="form-group"  *ngIf="isManager">
               <label>Is On Behalf?</label>
               <select2 [data]="onBehalf" [(ngModel)]="behalf" (update)="isOnBehalf($event)" formControlName="is_on_behalf"></select2>
            </div> -->
          <div class="form-group" *ngIf="behalf == '1'">
            <label
              >On Behalf Created For<span class="text-danger">*</span></label
            >
            <select2
              [data]="onBehalfEmp"
              placeholder="Select Employee"
              formControlName="on_behalf_created_by"
              (update)="updateLeaveType($event)"
            ></select2>
            <div
              *ngIf="submitted && empLeaveError.on_behalf_created_by.errors"
              class="form-error"
            >
              <div *ngIf="empLeaveError.on_behalf_created_by.errors.required">
                Created By is required !
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Leave Type <span class="text-danger">*</span></label>
            <select2
              [data]="lveType"
              (update)="chosenType($event)"
              formControlName="lv_type"
              placeholder="Select Leave Type"
            ></select2>
            <div
              *ngIf="submitted && empLeaveError.lv_type.errors"
              class="form-error"
            >
              <div *ngIf="empLeaveError.lv_type.errors.required">
                Leave Type is required !
              </div>
            </div>
            <span style="color: red" *ngIf="lv_type === 15 || lv_type === 16">
              applicable to employee's who covered under ESI
            </span>
            <div *ngIf="lvRules.helptext != ''" class="form-error">
              {{ lvRules.helptext }}
            </div>
          </div>
          <div class="form-group">
            <label>From <span class="text-danger">*</span></label>
            <input
              class="form-control"
              type="date"
              formControlName="from_date"
              [min]="CurDate"
              [max]="maxToDate"
              (input)="getFromDate()"
            />
            <div
              *ngIf="submitted && empLeaveError.from_date.errors"
              class="form-error"
            >
              <div *ngIf="empLeaveError.from_date.errors.required">
                From Date is required !
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>To <span class="text-danger">*</span></label>
            <input
              class="form-control"
              type="date"
              formControlName="to_date"
              [min]="from_date"
              [max]="maxToDate"
              (change)="getToDate()"
            />
            <div
              *ngIf="submitted && empLeaveError.to_date.errors"
              class="form-error"
            >
              <div *ngIf="empLeaveError.to_date.errors.required">
                To Date is required !
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Number of days <span class="text-danger">*</span></label>
            <input
              class="form-control"
              type="text"
              readonly
              formControlName="no_of_days"
            />
          </div>

          <div class="form-group" *ngIf="no_of_days == 1">
            <label>Full / Half Day <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="fhDay">
              <option value="1">Full Day</option>
              <option value="0.5">Half Day</option>
            </select>
          </div>
          <div class="form-group">
            <label>Leave Reason</label>
            <textarea
              rows="4"
              class="form-control"
              formControlName="reason"
              placeholder="Reason.."
            ></textarea>
            <div
              *ngIf="submitted && empLeaveError.reason.errors"
              class="form-error"
            >
              <div *ngIf="empLeaveError.reason.errors.required">
                Reason is Required !
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="lv_type === 3 && no_of_days > 3">
            <label>Doctor Certificate<span class="text-danger">*</span></label>
            <input
              class="form-control"
              type="file"
              formControlName="doc_attachment"
              (change)="onFileChange($event)"
            />
            <div
              *ngIf="submitted && empLeaveError.doc_attachment.errors"
              class="form-error"
            >
              <div *ngIf="empLeaveError.doc_attachment.errors.required">
                Document is Required !
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary btn-sm" type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
